module.exports = __webpack_public_path__ + "img/744.3213687b.jpg";